export interface TFAState {
  TFAStatus: boolean;
  TFAStatusLoaded: boolean;
  TFAStatusLoading: boolean;
}

export const initialTFAState: TFAState = {
  TFAStatus: true,
  TFAStatusLoaded: false,
  TFAStatusLoading: false
};
